import React from 'react';

import { Hole } from '../types/Hole';

interface PinSheetCircleProps {
  size: number;
  hole: Hole;
}

export default function PinSheetCircle({ size, hole }: PinSheetCircleProps) {
  const fromMiddle =
    (hole.pinData?.depth ?? 0) / 2 - (hole.pinData?.front ?? 0);

  return (
    <div className="p-1">
      <div
        className="flex mx-auto justify-center"
        style={{ fontSize: size / 7 }}
      >
        Depth: {hole.pinData?.depth ?? 0}
      </div>

      <div className="mx-auto">
        <svg width={size} height={size} style={{ overflow: 'visible' }}>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={size / 2}
            fill="white"
            stroke="black"
            strokeWidth={2}
          />
          {hole.pinData?.right && (
            <>
              <text
                x={size - size / 5}
                y={size / 2 - 5}
                fontSize={size / 5}
                textAnchor="middle"
              >
                {hole.pinData?.right}
              </text>
              <line
                x1={size / 2}
                y1={size / 2}
                x2={size}
                y2={size / 2}
                stroke="black"
                strokeWidth="2"
              />
            </>
          )}
          {hole.pinData?.left && (
            <>
              <text
                x={size / 5}
                y={size / 2 - 5}
                fontSize={size / 5}
                textAnchor="middle"
              >
                {hole.pinData?.left}
              </text>
              <line
                x1={size / 2}
                y1={size / 2}
                x2={0}
                y2={size / 2}
                stroke="black"
                strokeWidth="2"
              />
            </>
          )}
          {hole.pinData?.front && (
            <>
              <text
                x={size / 2 + size / 7}
                y={size - size / 5}
                fontSize={size / 5}
                textAnchor="middle"
              >
                {hole.pinData?.front}
              </text>
              <line
                x1={size / 2}
                y1={size / 2}
                x2={size / 2}
                y2={size}
                stroke="black"
                strokeWidth="2"
              />
            </>
          )}
        </svg>
      </div>

      <div
        className={`flex mx-auto justify-center`}
        style={{ fontSize: size / 7 }}
      >
        {fromMiddle >= 0 ? fromMiddle * -1 : `+${fromMiddle * -1}`}
      </div>
    </div>
  );
}
